export const config = {
    defaults: {
        view: 'default',
    },
    variations: {
        view: {},
    },
};
